import { render, staticRenderFns } from "./ModelEditor.vue?vue&type=template&id=0c88b3db"
import script from "./ModelEditor.vue?vue&type=script&lang=js"
export * from "./ModelEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports